<template>
    <div class="kit-card">
        <img v-if="kit.thumbnail" :src="kit.thumbnail.file" alt="" class="kit-card__image">

        <div class="kit-card__infos">
            <h4 class="card-title">
                <span v-html="kit.title"></span>
            </h4>
            <p class="card-description" v-html="kit.description"></p>

            <div class="kit-card__footer">
                <div class="kit-card__price" v-html="`<small>R$ </small>${kit.payment_price}`"></div>
                <p class="kit-card__subprice"  v-if="kit.payment_subprice != ''" v-html="kit.payment_subprice"></p>
                <a @click="gaTrackStore" :href="kit.link" class="btn btn-lg" target="_blank">
                    {{ $root.t('Ir à loja') }}
                </a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props : [ 'kit', 'category' ],
    methods: {
        gaTrackStore() {
            this.$gtm.trackEvent({
                eventCategory:'Treine em Casa',
                event: 'gaEvent',
                eventAction: 'Loja',
                eventLabel: this.kit.title
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/settings/_variables.scss";
@import "@/assets/scss/settings/_mixins.scss";

.kit-card {
    border-radius: 8px;
    background-color: darken($c_gray-dark, 12%);
    overflow: hidden;
    text-align: center;
    transition: all .6s;
    height: 100%;
    display: flex;
    flex-wrap: wrap;
    align-items: center;

    &:hover{ border-color: $c_primary; }

    &__image {
        width: 100%;
        align-self: flex-start;
    }

    &__infos {
        padding: 20px;
    }

    .card-title span {
        font-size: 26px;
    }

    &__price {
        font-weight: bold;
        font-size: 27px;
        margin-bottom: 10px;
        color: white;

        /deep/ small {
            font-size: 16px;
            vertical-align: 7px;
        }
    }

    &__subprice {
        font-size: 13px;
        color: lighten($c_gray-dark, 12%);
        line-height: 1.2;
        border-radius: 5px;
        padding: 10px;
        font-weight: 500;
    }
}
</style>
